module.exports = __webpack_public_path__ + "static/img/ma.368f417.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ma.png
// module id = rFwP
// module chunks = 1